module.exports = __webpack_public_path__ + "static/img/3.7143e44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/3.png
// module id = biLy
// module chunks = 0